exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".bot-caption[data-v-7eb2bc79] {\n  max-width: 58%;\n}\n.bot-caption>div[data-v-7eb2bc79] {\n  margin-left: 200px;\n}\n.bot-caption>div h3[data-v-7eb2bc79] {\n  font-size: 60px;\n}\n.bot-caption>div h5[data-v-7eb2bc79] {\n  font-size: 32px;\n}\n.bot-caption>div .bot-text[data-v-7eb2bc79] {\n  font-size: 22px;\n  opacity: 0.8;\n}\n.alert-message[data-v-7eb2bc79] {\n  max-width: 600px;\n  display: block;\n  margin: 0 auto;\n}\n[data-v-7eb2bc79] .alert-message .v-alert__content {\n  display: inline-flex;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/stylus-loader!./node_modules/vue-loader/lib??vue-loader-options!./src/views/home.vue?vue&type=style&index=0&id=7eb2bc79&lang=stylus&scoped=true&
// module id = 733
// module chunks = 9